import dayjs from 'dayjs';

export type Preset = {
  label: string;
  value: string;
  getRange: () => [Date, Date];
};

export const defaultPresets: Preset[] = [
  {
    label: 'Today',
    value: 'today',
    getRange: () => {
      const d = new Date();
      return [d, d];
    },
  },
  {
    label: 'Yesterday',
    value: 'yesterday',
    getRange: () => {
      const y = dayjs().subtract(1, 'day').toDate();
      return [y, y];
    },
  },
  {
    label: 'Last 7 Days',
    value: 'last_7_days',
    getRange: () => [dayjs().subtract(6, 'day').toDate(), new Date()],
  },
  {
    label: 'Last Week',
    value: 'last_week',
    getRange: () => {
      const start = dayjs().subtract(1, 'week').startOf('week').toDate();
      const end = dayjs().subtract(1, 'week').endOf('week').toDate();
      return [start, end];
    },
  },
  {
    label: 'This Month',
    value: 'this_month',
    getRange: () => {
      const start = dayjs().startOf('month').toDate();
      const end = new Date();
      return [start, end];
    },
  },
  {
    label: 'Last Month',
    value: 'last_month',
    getRange: () => {
      const start = dayjs().subtract(1, 'month').startOf('month').toDate();
      const end = dayjs().subtract(1, 'month').endOf('month').toDate();
      return [start, end];
    },
  },
  {
    label: 'Last 12 Months',
    value: 'past_12_months',
    getRange: () => {
      const start = dayjs().subtract(11, 'month').startOf('month').toDate();
      const end = new Date();
      return [start, end];
    },
  },
];

export const getRanges = (period: string): [Date | null, Date | null] => {
  const found = defaultPresets.find(p => p.value === period) as Preset;
  if (!found) return [null, null];
  return found.getRange();
};
